import { useState } from "react";
import { postUserURL } from "../../utils/ConstantsURL";

export const usePostUser = (token) => {
  const [loading, setLoading] = useState(false);

  const addUser = async (dataForm) => {
    setLoading(true);
    try {
      let response = await fetch(postUserURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(dataForm),
      });

      let data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Error en la solicitud");
      }
      setLoading(false);
    } catch (error) {
      console.error("Error al agregar el usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  return { addUser, loading };
};
